import { useCallback, useState } from 'react';
import NavigationModule from '../../features/NavigationModule/NavigationModule';
import { MOBILE_NAV_HEIGHT } from '../../core/constants/layout';
import { Flex } from '../ui/provider';
import { SquaresFourIcon } from '@phosphor-icons/react/dist/csr/SquaresFour';
import { ChatsIcon } from '@phosphor-icons/react/dist/csr/Chats';
import { ListIcon } from '@phosphor-icons/react/dist/csr/List';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useIsDesktop } from '../../core/hooks/useMediaQuery';
import NavbarMobileButton from './NavbarMobileButton';
import { useApp } from '../../core/contexts/AppContext';
import { useIsAliciaEnabled } from '../../core/hooks/useIsAliciaEnabled';

const Navbar = () => {
  const isDesktop = useIsDesktop();
  const { t } = useTranslation(['common']);
  const {
    isMenuOpen,
    setIsMenuOpen,
    isAliciaChatbotMenuOpen,
    setIsAliciaChatbotMenuOpen,
    handleOpenAliciaChatbot,
    handleOpenMenu,
    handleCloseMenu,
    setIsNotificationDrawerOpen,
  } = useApp();
  const navigate = useNavigate();
  const isAliciaEnabled = useIsAliciaEnabled();

  const isHomePage = window.location.pathname === '/' || window.location.pathname === '/home';
  const isInitialPageSelected = isHomePage && !isMenuOpen && !isAliciaChatbotMenuOpen;

  const [isSiteSelectorOpen, setIsSiteSelectorOpen] = useState(false);

  const handleInitialPage = useCallback(() => {
    setIsMenuOpen(false);
    setIsAliciaChatbotMenuOpen(false);
    // Switching to the Home view always leaves the notifications drawer behind.
    setIsNotificationDrawerOpen(false);

    if (!isHomePage) {
      navigate('/home');
    }
  }, [
    navigate,
    isHomePage,
    setIsMenuOpen,
    setIsAliciaChatbotMenuOpen,
    setIsNotificationDrawerOpen,
  ]);

  const handleSiteSelectorOpen = useCallback((isOpen: boolean) => {
    setIsSiteSelectorOpen(isOpen);
  }, []);

  return (
    <>
      <NavigationModule
        isFullScreen={!isDesktop}
        isOpen={isDesktop ? undefined : isMenuOpen}
        setIsMenuOpen={!isDesktop ? setIsMenuOpen : undefined}
        onClose={!isDesktop ? handleCloseMenu : undefined}
        bottomOffset={!isDesktop ? (isSiteSelectorOpen ? '0px' : MOBILE_NAV_HEIGHT) : undefined}
        onSiteSelectorOpen={!isDesktop ? handleSiteSelectorOpen : undefined}
      />

      {!isDesktop && !isSiteSelectorOpen && (
        <Flex
          width='100vw'
          h={MOBILE_NAV_HEIGHT}
          position='fixed'
          bottom='0'
          zIndex='1000'
          justifyContent='space-between'
          alignItems='center'
          fontSize='sm'
          backgroundColor='navigationBar.background'
          borderTop='1px solid'
          borderColor='navigationBar.border'
        >
          <NavbarMobileButton
            label={t('navbarMobile.homePage')}
            icon={SquaresFourIcon}
            isActive={isInitialPageSelected}
            onClick={handleInitialPage}
          />
          {isAliciaEnabled && (
            <NavbarMobileButton
              label={t('navbarMobile.alicia')}
              icon={ChatsIcon}
              isActive={isAliciaChatbotMenuOpen}
              onClick={handleOpenAliciaChatbot}
            />
          )}
          <NavbarMobileButton
            label={t('navbarMobile.menu')}
            icon={ListIcon}
            isActive={isMenuOpen}
            onClick={handleOpenMenu}
          />
        </Flex>
      )}
    </>
  );
};

export default Navbar;
